import { render } from "./Main.vue?vue&type=template&id=07db3a7c"
const script = {}
script.render = render

export default script